// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const TerminalReaderComparison: MarkdocTagRegistration = {
  tag: 'terminal-reader-comparison',
  component: 'TerminalReaderComparison',
  attributes: {
    country: {
      type: String,
      description: "The viewing user's country",
      localizable: false,
    },
    compatibilityData: {
      type: Object,
      description:
        'Terminal country compatibility data from the terminal context',
      localizable: false,
    },
  },
};
